import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NetworkStateType = {
  nowNetwork: string;
};

const INIT_STATE: NetworkStateType = {
  nowNetwork: localStorage.getItem("chanIndex")?localStorage.getItem("chanIndex")=='0'?"JuChain Mainnet":"JuChain Testnet":"JuChain Mainnet", // 设置默认网络
};

export const networkSlice = createSlice({
  name: "network",
  initialState: INIT_STATE,
  reducers: {
    // 设置网络
    setNowNetwork: (state, action: PayloadAction<string>) => {
      state.nowNetwork = action.payload;
    },
  },
});

export const { setNowNetwork } = networkSlice.actions;

export default networkSlice.reducer;
